///include /assets/js/app/p/brand.js
///include /assets/js/app/s/catalogue.js
///include /assets/js/app/p/cloud-product-helper.js
///include /assets/js/app/p/cloud-server-builder.js
///include /assets/js/app/s/payment-selection.js
///include /assets/js/app/s/basket/payment-selection.js
///include /assets/js/app/s/checkout-basket.js
///include /assets/js/app/s/order-wrapper-v2.js
///include /assets/js/app/p/tax-display.js

class SBuildServerPage {
    init() {
        this.view = new Vue({
            el: "#build-server",
            name: "build-server-page",
            data() {
                return {
                    inProgress: false,
                    lightStackCpTheme:["bs", "b2", "b3", "bs", "bs11"],
                    addingCard: false,
                    backgrounds: _BACKGROUNDSLIGHT,

                    balance: undefined,
                    /** @type {SCheckoutBasket} */
                    //@ts-ignore
                    basket: AnyBasket.inst,
                    // billingPeriodYearly: false,
                    billingPeriodSelected: "M",
                    /** @type {?Brand} */
                    brand: window.brand ? window.brand : null,
                    catalogue: UserCatalogue.inst,
                    checkoutInfo: CheckoutInfo.inst,
                    /** @type {?CloudProductHelper} */
                    cloudProductHelper: null,
                    /** @type {SBCloudServerBuilder} */
                    cloudServerBuilder: new SBCloudServerBuilder(),
                    format: Site.Format,
                    loading: true,

                    /**
                     * What the backend says this server would really cost.
                     * Null until asked, or whenever the request failed - in
                     * which case the client side price stands, exactly as it
                     * did before the preview existed.
                     * @type {?{price: ?string, originalPrice: ?string, discount: ?{code: string, description: string, amount: string}, hasNoAutoApplyCodes: boolean, codeApplied: boolean}}
                     */
                    discountPreview: null,
                    /**
                     * The discountPreviewKey the preview above was asked for,
                     * so a preview for an earlier configuration is never used.
                     * @type {?string}
                     */
                    discountPreviewFor: null,
                    /** Counts preview requests, so a late reply can't win. */
                    discountPreviewSeq: 0,
                    /** The code typed into the box, before it is checked. */
                    discountCodeInput: "",
                    /** The code confirmed as applying, sent to the basket on buy. */
                    discountCodeMessage: "",
                    /** @type {?string} */
                    appliedDiscountCode: null,
                    checkingDiscountCode: false,
                    /** Debounce handle for the preview request. @type {?number} */
                    discountPreviewTimer: null,

                    /** @type {ServerLocationUtils} */
                    locationUtilities: ServerLocationUtils,
                    minSpecRequired: ['WooCommerce', 'Magento'],
                    /** @type {Object[]} */
                    paymentItems: [],
                    preAuthUrl: "",
                    responsiveBandwidthInput: "",
                    responsiveDiskInput: "",
                    responsiveServerSelect: null,
                    selectedPaymentItem: null,
                    serverNameInput: "",
                    useRazorpay: false,
                    validData: {
                        responsiveBandwidthInput: true,
                        responsiveDiskInput: true,
                        serverNameInput: true,
                    },
                    useAccountBalance: false,
                    user: User.inst,
                    userId: "",
                }
            },
            watch: {
                /**
                 * Re-price whenever the configuration changes.
                 *
                 * Debounced because the spec, disk and bandwidth controls move
                 * continuously as the customer drags them, and each change is a
                 * request that runs the discount matcher.
                 */
                discountPreviewKey: {
                    handler() {
                        if (this.discountPreviewTimer) {
                            clearTimeout(this.discountPreviewTimer)
                        }
                        this.discountPreviewTimer = setTimeout(() => {
                            this.discountPreviewTimer = null
                            this.refreshDiscountPreview(null)
                        }, 400)
                    },
                    immediate: true,
                },
                /**
                 * Load the page corectly without flashing the shop closed
                 * component on to the screen (unless it's required)
                 */
                "catalogue.isOpen": {
                    handler() {
                        // cloudProductHelper may not be ready yet if the catalogue
                        // resolved before our Promise.all — mounted() handles that case
                        if (this.cloudProductHelper) {
                            setTimeout(() => {
                                this.loading = false
                            }, 100)
                        }
                    },
                    deep: true
                },
                "cloudServerBuilder.cloudProvider": {
                    handler(v) {
                        if (v) {
                            /**
                             * Clear the specs that will get re-populated
                             * automatically when the sliders re-render and
                             * select the below options. The prevents mismatched
                             * values being passed to the cloudProductHelper
                             * when switching between clouds.
                             */
                            this.cloudServerBuilder.configuredDiskSpace = ""
                            this.cloudServerBuilder.predictedBandwidth = ""
                            this.cloudServerBuilder.specName = ""
                            this.cloudServerBuilder.zone = ""
                        }
                    },
                    deep: true
                },
                "cloudServerBuilder.serverName": {
                    handler(v, o) {
                        if (v && v != o) {
                            this.serverNameInput = v
                        }
                    },
                    deep: true
                },
                preAuthUrl(v) {
                    if (v) {
                        setTimeout(
                            () => {
                                /** @type {HTMLFormElement} */
                                //@ts-ignore
                                const f = this.$el.querySelector("form#preauth")
                                f.submit()
                            },
                            250
                        )
                    }
                },
                serverNameInput(v) {
                    if (
                        !v.match(/^[A-Za-z0-9\s\.\-]*$/) ||
                        v.length > this.cloudServerBuilder.maxServerNameLength
                    ) {
                        return this.validData.serverNameInput = false
                    }

                    this.cloudServerBuilder.serverName = v.trim()
                    return this.validData.serverNameInput = true
                },
                /**
                 * RESPONSIVE
                 *
                 * "cloudServerBuilder.<spec>" options are to keep the values up
                 * to date across inputs as the inputs differ on mobile devices
                 * from desktop - the way they are done will prevent infinite
                 * loops but cause the select<spec>() methods to run twice.
                 *
                 * responsive<spec> watchers are to validate user input and set
                 * the corresponding values correctly.
                 */
                "cloudServerBuilder.configuredDiskSpace": {
                    handler(v, o) {
                        if (v && v != o) {
                            this.responsiveDiskInput = v
                        }
                    },
                    deep: true
                },
                "cloudServerBuilder.predictedBandwidth": {
                    handler(v, o) {
                        if (v && v != o) {
                            this.responsiveBandwidthInput = v
                        }
                    },
                    deep: true
                },
                "cloudServerBuilder.specName": {
                    handler(v, o) {
                        if (v && v != o) {
                            this.responsiveServerSelect = v
                        }
                    },
                    deep: true
                },
                responsiveBandwidthInput(v) {
                    let value = +v

                    if (
                        this.cloudProductHelper?.hasPayAsYouGoBandwidth(
                            this.cloudServerBuilder.cloudProvider
                        )
                    ) {
                        const min = this.cloudProductHelper.predictedBandwidthMin()
                        const max = this.cloudProductHelper.predictedBandwidthMax()

                        if (value < min || value > max) {
                            return this.validData.responsiveBandwidthInput = false
                        }
                    }

                    // @ts-ignore
                    this.selectBandwidth(value)
                    return this.validData.responsiveBandwidthInput = true
                },
                responsiveDiskInput(v) {
                    let value = +v

                    if (
                        this.cloudProductHelper?.hasConfigurableDiskSpace(
                            this.cloudServerBuilder.cloudProvider,
                            this.cloudServerBuilder.specName,
                        )
                    ) {
                        const min = this.cloudProductHelper?.diskRangeMin(
                            this.cloudServerBuilder.cloudProvider,
                            this.cloudServerBuilder.specName
                        )
                        const max = this.cloudProductHelper?.diskRangeMax(
                            this.cloudServerBuilder.cloudProvider,
                            this.cloudServerBuilder.specName
                        )

                        if (value < min || value > max) {
                            return this.validData.responsiveDiskInput = false
                        }
                    }

                    // @ts-ignore
                    this.selectDiskSpace(value)
                    return this.validData.responsiveDiskInput = true
                },
                responsiveServerSelect(v) {
                    if (v) {
                        const prod = this.cloudProductHelper?.cloudProduct(
                            this.cloudServerBuilder.cloudProvider,
                            v
                        )

                        if (prod) {
                            // @ts-ignore
                            this.selectCloudProduct(prod)
                        }
                    }
                },
            },
            components: {
                'bandwidth-slider': BandwidthSlider,
                'disk-slider': DiskSlider,
                paymentSelection: SPaymentSelection,
                'server-slider': ServerSlider,
                vueSelect: VueSelect,
            },
            computed: {
                billingPeriodYearly() {
                    return this.billingPeriodSelected === "M" ? false : true;
                },
                selectedTheme(){
                    return this.lightStackCpTheme.includes(window.brand?.themeName)
                },
                canConfigureBandwidth() {
                    if (
                        this.cloudServerBuilder.cloudProvider &&
                        this.cloudServerBuilder.specName
                    ) {
                        return this.cloudProductHelper?.hasPayAsYouGoBandwidth(
                            this.cloudServerBuilder.cloudProvider
                        )
                    }

                    return false
                },
                canConfigureDiskSpace() {
                    if (
                        this.cloudServerBuilder.cloudProvider &&
                        this.cloudServerBuilder.specName
                    ) {
                        return this.cloudProductHelper?.hasConfigurableDiskSpace(
                            this.cloudServerBuilder.cloudProvider,
                            this.cloudServerBuilder.specName
                        )
                    }

                    return false
                },
                /**
                 * Get the index of the selected product to pass to the server
                 * slider.
                 *
                 * This is used to force an update on the server slider when the
                 * value has been changed away from the server slider (i.e.
                 * responsive select input). Because the server slider counts
                 * from 1 we add 1 to the found index (if applicable) or pass a
                 * default value of 3 to land on 'medium'.
                 */
                cloudProductIndex() {
                    let options = this.cloudProductHelper?.cloudProductOptions(
                        this.cloudServerBuilder.cloudProvider
                    )

                    if (
                        this.minSpecRequired.includes(
                            this.cloudServerBuilder.optimisationProfile
                        )
                    ) {
                        options = options.filter(prod => {
                            return +prod.detail.ram.options[0] >= 4
                        })
                    }

                    if (Array.isArray(options) && this.cloudServerBuilder.specName) {
                        let index = options.findIndex(
                            cs => cs.specName == this.cloudServerBuilder.specName
                        )

                        return +index > -1 ? +index + 1 : 3
                    }

                    return 3
                },
                /**
                 * What the auto-apply or entered code takes off, ex-VAT.
                 *
                 * The preview covers the SERVER item only, so a timeline
                 * backups addon is not discounted here even though it is its
                 * own basket item and could carry its own code.
                 */
                /**
                 * Everything the price and the discount depend on, as one
                 * string, so the watcher fires once per real change rather than
                 * once per property.
                 */
                discountPreviewKey() {
                    return [
                        this.cloudServerBuilder.cloudProvider,
                        this.cloudServerBuilder.specName,
                        this.cloudServerBuilder.basketConfig
                            ? this.cloudServerBuilder.basketConfig.zone
                            : "",
                        this.cloudServerBuilder.basketConfig
                            ? this.cloudServerBuilder.basketConfig.optimisation
                            : "",
                        this.cloudServerBuilder.configuredDiskSpace,
                        this.billingPeriodYearly ? 12 : 1,
                        this.basket ? this.basket.currency : "",
                    ].join("|")
                },
                /**
                 * The backend preview, only if it is for the configuration on
                 * screen and has a price. The basket prices the server with
                 * the same code, so whenever this exists it is what the
                 * customer will be charged, and the summary uses it.
                 *
                 * @returns {?Object}
                 */
                currentPreview() {
                    const p = this.discountPreview
                    if (
                        !p ||
                        this.discountPreviewFor !== this.discountPreviewKey ||
                        p.price === null || p.price === undefined ||
                        p.total === null || p.total === undefined
                    ) {
                        return null
                    }
                    return p
                },
                /**
                 * What comes off, ex-VAT, as shown on the discount line.
                 *
                 * Derived as (undiscounted sub total - payable sub total)
                 * rather than taken from the backend's own amount, so the
                 * figures on screen always reconcile: the line items minus this
                 * equals the sub total below it. Where the client side price and
                 * the backend's differ by a rounding step, that difference lands
                 * here rather than making the column fail to add up.
                 *
                 * The preview covers the SERVER item only, so a timeline backups
                 * addon is not discounted even though it is its own basket item
                 * and could carry its own code.
                 */
                discountAmount() {
                    if (!this.hasBackendDiscount) {
                        return 0
                    }
                    const off = this.undiscountedSubTotal - this.subTotal
                    return off > 0 ? Math.round(off * 100) / 100 : 0
                },
                /** Did the backend report a discount at all? */
                hasBackendDiscount() {
                    return !!(
                        this.currentPreview &&
                        this.currentPreview.discount &&
                        +this.currentPreview.discount.amount > 0
                    )
                },
                hasDiscount() {
                    // Deliberately NOT discountAmount, which is derived from
                    // subTotal, which is derived from this - that would be a
                    // circular computed.
                    return this.hasBackendDiscount
                },
                /**
                 * The label for the discount line.
                 *
                 * Resolved here rather than in the template because there is no
                 * global translate() in the browser - only the translation
                 * singleton - so calling it from a Vue expression would throw
                 * at render time.
                 */
                discountDescription() {
                    const described = this.discountPreview && this.discountPreview.discount ?
                        this.discountPreview.discount.description :
                        ""
                    return described || translation.get('build_server_order_summary_discount')
                },
                /**
                 * Offer the code input only when the reseller has a live code
                 * that would target this server. The backend deliberately does
                 * not say which code, so the customer needs it from the
                 * reseller's marketing.
                 */
                showDiscountCodeBox() {
                    return !!(
                        this.discountPreview && this.discountPreview.hasNoAutoApplyCodes
                    )
                },
                /** The server price before any discount, for the struck-through figure. */
                undiscountedSubTotal() {
                    // @ts-ignore
                    if (this.pricing.serverConfiguredPrice) {
                        // The backend's price where there is one, so this and
                        // the payable sub total below come from the same place
                        // and the discount line is the only difference.
                        const price = this.currentPreview &&
                            this.currentPreview.originalPrice !== null &&
                            this.currentPreview.originalPrice !== undefined ?
                            +this.currentPreview.originalPrice :
                            // @ts-ignore
                            +this.pricing.serverConfiguredPrice

                        return price + this.timelineAddonPrice
                    }

                    return 0
                },
                /**
                 * The timeline backups addon, ex-VAT, if chosen. The preview
                 * covers the server only, so this is added on top of it.
                 *
                 * @returns {number}
                 */
                timelineAddonPrice() {
                    if (
                        // @ts-ignore
                        this.timelineProPricing &&
                        this.cloudServerBuilder.timelineBackups === "pro"
                    ) {
                        // @ts-ignore
                        return +this.timelineProPricing
                    }
                    return 0
                },
                /**
                 * The payable sub total, ie after any discount. VAT and the
                 * grand total are both derived from this, so the discount flows
                 * through to what the customer is actually charged - a discount
                 * line that did not change the total would be a lie.
                 */
                subTotal() {
                    let net
                    if (this.currentPreview) {
                        // The backend's price, discounted or not, because the
                        // basket charges exactly this. Taking the sub total
                        // from the page and the total from the backend is what
                        // once showed a price mismatch as "VAT".
                        //
                        // Deliberately NOT discountAmount, which is derived from
                        // this - that would be a circular computed and Vue
                        // blows the stack rendering it.
                        net = +this.currentPreview.price + this.timelineAddonPrice
                    } else {
                        // No preview (yet) for this configuration: the page's
                        // own figure, as a placeholder
                        net = this.undiscountedSubTotal
                    }

                    return net > 0 ? Math.round(net * 100) / 100 : 0
                },
                /**
                 * What the customer actually pays.
                 *
                 * The basket charges price + price * vatRate and rounds ONCE.
                 * Rounding the VAT first and then adding is not the same sum -
                 * it lands a penny high at 19%, 21%, 23% and 5% VAT (never at
                 * 20%, which is why this hid for a while) - so the total is
                 * taken from the backend where it can be, and computed with a
                 * single rounding where it cannot.
                 *
                 * The backend figure covers the SERVER only, so it is used
                 * directly only when there is no timeline addon to add on top.
                 */
                grandTotal() {
                    // @ts-ignore
                    if (!this.pricing.serverConfiguredPrice) {
                        return 0
                    }

                    /**
                     * The backend's total wins when there is one, because the
                     * basket does not tax at the nominal rate: it stores each
                     * item's VAT rounded to 2dp and setDiscountCodeMatch() then
                     * derives the rate back out of that, so the effective rate
                     * is slightly off nominal. Recomputing here from the rate
                     * lands a penny high - 8.89 at 21% is 10.76 nominally but
                     * 10.75 as charged.
                     *
                     * A timeline addon is its own basket item with its own
                     * rounded VAT, so it is added the same way rather than
                     * being folded into one multiplication.
                     */
                    if (this.currentPreview) {
                        let total = +this.currentPreview.total

                        const tl = this.timelineAddonPrice
                        if (tl) {
                            total += tl + Math.round(tl * this.vatRate * 100) / 100
                        }

                        return Math.round(total * 100) / 100
                    }

                    // No preview: one multiply, one round, which is still closer
                    // than rounding the VAT and adding it.
                    return Math.round(this.subTotal * (1 + this.vatRate) * 100) / 100
                },
                /**
                 * The VAT rate as a fraction.
                 *
                 * The backend's figure wins when there is one, because
                 * Config::getVATRatePercentFor() is what actually decides: a
                 * reseller has to be VAT registered to charge VAT at all, and
                 * the rate then depends on place of supply, whether the
                 * customer is in the EU and whether they have a VAT number.
                 * catalogue.userVATRate can disagree with that, and when it
                 * does the summary disagrees with the invoice.
                 *
                 * Falls back to catalogue.userVATRate only when the preview is
                 * unavailable, so the page still shows tax if the request fails.
                 */
                vatRate() {
                    if (
                        this.currentPreview &&
                        this.currentPreview.vatRatePercent !== null &&
                        this.currentPreview.vatRatePercent !== undefined
                    ) {
                        return +this.currentPreview.vatRatePercent / 100
                    }
                    if (this.catalogue && this.catalogue.userVATRate) {
                        return +this.catalogue.userVATRate / 100
                    }
                    return 0
                },
                hasInvalidData() {
                    if (
                        !this.validData.serverNameInput ||
                        !this.validData.responsiveDiskInput ||
                        !this.validData.responsiveBandwidthInput
                    ) {
                        return true
                    }

                    return false
                },
                offersAnnualPricing() {
                    return this.cloudProductHelper.settings.offersAnnualPricing.includes(
                        this.cloudServerBuilder.cloudProvider
                    )
                },
                offerTimelineBackups() {
                    return this.cloudProductHelper.settings.timelineBackupsPro
                },
                offerYearlyDiscount() {
                    // Not currently supported in HS
                    return false
                },
                pricing() {
                    if (
                        this.cloudServerBuilder.cloudProvider &&
                        this.cloudServerBuilder.specName &&
                        this.cloudServerBuilder.configuredDiskSpace &&
                        this.cloudServerBuilder.predictedBandwidth &&
                        this.cloudServerBuilder.zone
                    ) {
                        return this.cloudProductHelper?.allPricing(
                            this.cloudServerBuilder.cloudProvider,
                            this.cloudServerBuilder.specName,
                            this.cloudServerBuilder.configuredDiskSpace,
                            this.cloudServerBuilder.predictedBandwidth,
                            this.cloudServerBuilder.zone,
                            this.billingPeriodYearly ? "yearly" : "monthly",
                            this.catalogue.config.currency,
                            false,
                            true
                        )
                    }

                },
                billingPeriodMessageM() {
                    return "Monthly"
                },
                billingPeriodMessageY() {
                    return "Yearly";
                },

                billingPeriodOptions() {
                    return [
                        { id: "M", text: this.billingPeriodMessageM },
                        { id: "Y", text: this.billingPeriodMessageY }
                    ]
                },
                remainingCharacters() {
                    return this.cloudServerBuilder.maxServerNameLength - this.cloudServerBuilder.serverName.length
                },
                timelineProPricing() {
                    // @ts-ignore
                    if (this.pricing && this.pricing.serverConfiguredPrice) {
                        return Math.round(
                            // @ts-ignore
                            (+this.pricing.serverConfiguredPrice * +this.cloudProductHelper.timelineBackupsProPercent) * 100
                        ) / 100
                    }
                },
                /**
                 * Derived as (total - sub total) rather than computed, so the
                 * VAT shown and the total shown always agree with each other
                 * and with what is charged. Computing it independently is what
                 * put the summary a penny out.
                 */
                vat() {
                    if (
                        !this.vatRate ||
                        // @ts-ignore
                        !this.pricing ||
                        // @ts-ignore
                        !this.pricing.serverConfiguredPrice
                    ) {
                        return 0
                    }
                    // total - sub total, so the VAT shown, the total shown and
                    // the amount charged cannot disagree with each other.
                    const v = this.grandTotal - this.subTotal
                    return v > 0 ? Math.round(v * 100) / 100 : 0
                },
                vatLabel() {
                    return TaxDisplay.label(
                        this.catalogue && this.catalogue.userConfig,
                        // @ts-ignore
                        this.brand
                    )
                },
                /**
                 * RESPONSIVE
                 */
                responsiveCloudServerOptions() {
                    let options = this.cloudProductHelper?.cloudProductOptions(
                        this.cloudServerBuilder.cloudProvider
                    )

                    if (Array.isArray(options)) {
                        return options.map(option => {
                            option.id = option.specName
                            return option
                        })
                    }

                    return []
                },
                responsiveOptimisationProfileOptions() {
                    let options = []

                    for (const op in this.cloudProductHelper?.getDisplayOptimisationProfiles()) {
                        options.push(this.cloudProductHelper?.getDisplayOptimisationProfiles()[op])
                    }

                    return options
                },
            },
            methods: {
                /**
                 * @todo Timeline Backups
                 */
                async deployServer() {
                    if (this.inProgress) {
                        return
                    }
                    this.inProgress = true
                    try {
                        if (this.basket?.itemsFlat?.length) {
                            // Park any existing basket items to one side
                            sessionStorage.setItem(
                                'held-basket', JSON.stringify(this.basket.itemsFlat)
                            )

                            // Then empty any existing basket contents
                            this.basket.itemsFlat.map(bi => {
                                this.basket.removeItem(bi)
                            })
                        }

                        // Now check out, we'll re-populate any existing basket
                        // items at checkout finish
                        // @ts-ignore
                        await this.addToBasket()
                    } finally {
                        // Stay locked while the preauth form submits, or a
                        // second click places a second server order.
                        if (!this.preAuthUrl) {
                            this.inProgress = false
                        }
                    }
                },
                /**
                 * The serviceConfiguration for the server currently on screen.
                 *
                 * Shared by addToBasket() and the discount preview, so the
                 * price previewed and the server bought cannot describe
                 * different things.
                 *
                 * @param {boolean} includeName mvpsName is wanted when buying
                 *   but is noise for a price preview
                 */
                buildServiceConfiguration(includeName) {
                    const serviceConfiguration = {
                        optimisation: this.cloudServerBuilder.basketConfig.optimisation,
                        spec: this.cloudServerBuilder.basketConfig.spec,
                        zone: this.cloudServerBuilder.basketConfig.zone
                    }

                    if (includeName && this.cloudServerBuilder.serverName.length) {
                        serviceConfiguration["mvpsName"] = this.cloudServerBuilder.serverName
                    }

                    if (
                        this.cloudProductHelper?.hasConfigurableDiskSpace(
                            this.cloudServerBuilder.cloudProvider,
                            this.cloudServerBuilder.specName
                        )
                    ) {
                        if (
                            +this.cloudServerBuilder.configuredDiskSpace >
                            +this.cloudProductHelper.diskRangeMin(
                                this.cloudServerBuilder.cloudProvider,
                                this.cloudServerBuilder.specName
                            ) &&
                            +this.cloudServerBuilder.configuredDiskSpace <
                            +this.cloudProductHelper.diskRangeMax(
                                this.cloudServerBuilder.cloudProvider,
                                this.cloudServerBuilder.specName
                            )
                        ) {
                            serviceConfiguration["disk"] = this.cloudServerBuilder.configuredDiskSpace
                        }
                    }

                    return serviceConfiguration
                },
                /**
                 * Ask the backend what this server would actually cost, with
                 * any auto-apply discount, and whether a code input is worth
                 * offering.
                 *
                 * Debounced: the spec, disk and zone controls change as the
                 * customer drags them.
                 *
                 * @param {?string} code A code the customer has typed
                 */
                async refreshDiscountPreview(code) {
                    if (!this.cloudProductHelper || !this.cloudServerBuilder.specName) {
                        return
                    }
                    const config = this.buildServiceConfiguration(false)
                    config.provider = this.cloudServerBuilder.cloudProvider
                    config.periodMonths = this.billingPeriodYearly ? 12 : 1

                    // A reply only counts for the configuration it was asked
                    // about, and only if no later request has been made
                    const seq = ++this.discountPreviewSeq
                    const key = this.discountPreviewKey

                    let preview = null
                    try {
                        preview = await this.basket.cloudDiscountPreview(
                            config,
                            code || this.appliedDiscountCode || null
                        )
                    } catch (e) {
                        // Never let a price hint break the page. Falling back to
                        // no preview leaves the client side price on screen,
                        // which is what shipped before this existed.
                        preview = null
                    }
                    if (seq !== this.discountPreviewSeq) {
                        return
                    }
                    this.discountPreview = preview
                    this.discountPreviewFor = preview ? key : null
                },
                /**
                 * Preview the code the customer typed. If it does not win, say
                 * so rather than letting them buy expecting a discount.
                 */
                async checkDiscountCode() {
                    const entered = (this.discountCodeInput || "").trim()
                    if (!entered) {
                        return
                    }
                    this.checkingDiscountCode = true
                    this.discountCodeMessage = ""
                    try {
                        await this.refreshDiscountPreview(entered)
                        if (this.discountPreview && this.discountPreview.codeApplied) {
                            this.appliedDiscountCode = entered
                        } else {
                            this.appliedDiscountCode = null
                            this.discountCodeMessage = translation.get(
                                "build_server_discount_code_not_applicable"
                            )
                        }
                    } finally {
                        this.checkingDiscountCode = false
                    }
                },
                async addToBasket() {
                    const serviceConfiguration = this.buildServiceConfiguration(true)

                    // Set up a group value.
                    var group = Math.random();
                    serviceConfiguration['group'] = group;

                    var timelineItem = null;

                    var serverItem = {
                        action: null,
                        currency: this.basket.currency,
                        paymentType: "any",
                        periodMonths: this.billingPeriodYearly ? 12 : 1,
                        productCode: `cloud_server:${this.cloudServerBuilder.cloudProvider}`,
                        basket_pricing: 1,
                        serviceConfiguration
                    }
                    if (this.cloudServerBuilder.timelineBackups == "pro") {
                        timelineItem = {
                            action: null,
                            paymentType: "any",
                            periodMonths: 1,
                            productCode: `cloud_timeline:${this.cloudServerBuilder.cloudProvider}`,
                            basket_pricing: 1,
                            serviceConfiguration: serviceConfiguration,
                            dependentItems: [serverItem]
                        };
                    }

                    await this.basket.thaw()

                    await this.basket.addWithInfo(
                        {
                            paymentItemCountries: await (
                                PaymentItemCollection.inst
                            ).preloadSingle("countriesFlat"),
                        },
                        timelineItem ? timelineItem : serverItem
                    );

                    /**
                     * Apply the confirmed code before the basket is frozen and
                     * priced, or it would not reach this purchase.
                     *
                     * Only a code the preview already confirmed applies is sent:
                     * addDiscountCode stores whatever it is given without
                     * checking, so sending an unverified code would leave the
                     * customer believing in a discount they are not getting.
                     */
                    if (this.appliedDiscountCode) {
                        try {
                            await this.basket.addDiscountCode(this.appliedDiscountCode)
                        } catch (e) {
                            // The server is already in the basket, so failing
                            // the whole purchase over the discount would be
                            // worse than continuing without it. Checkout still
                            // offers a discount code field.
                        }
                    }

                    if( !this.user.userRef ){
                        window.location.href="/checkout";
                        return false;
                    }

                    await this.basket.freeze()
                    if( !this.useRazorpay ){
                        const paymentTuple = `${this.selectedPaymentItem.type}:${this.selectedPaymentItem.id}`
                        const order = new V2OrderWrapper(this.basket.ref, true)
                        const invoice = await order.generateInvoice()
                        const transaction = await invoice.addTransaction({ payment: paymentTuple })

                        if (transaction && transaction.id) {
                            this.preAuthUrl = `/preauthv2/${invoice.id}/transaction/${transaction.id}`
                        }
                    } else {
                        const razorpay = await Site.require_once("https://checkout.razorpay.com/v1/checkout.js");
                        const paymentTuple = "razorpay:";
                        const orderWrapper = new V2OrderWrapper(this.basket.ref, true)
                        const invoice = await orderWrapper.generateInvoice()
                        const transaction = await invoice.addTransaction({ payment: paymentTuple })
                        let order = await $.ajax(`/n/invoice/v2/${invoice.id}/transaction/${transaction.id}/getRazorpayOrderId`);
                        let user = User.inst;
                        let options = {
                            "key": this.checkoutInfo.info.razorpay.publicKey,
                            "handler": async (response) => {
                                let result = await $.ajax({
                                    method: "post",
                                    url: `/n/invoice/v2/${invoice.id}/transaction/${transaction.id}`,
                                    contentType: "application/json",
                                    data: JSON.stringify({
                                        id: null,
                                        jsonrpc: "2.0",
                                        method: "razorpayStep",
                                        params: [response]
                                    })
                                });
                                window.location.href = `/checkout-finish?invoice-id=${invoice.id}`;
                            },
                            "name": this.brand.brandName,
                            "image": "/brandLogo",
                            "order_id": order.orderId,
                            "customer_id": order.customerId,
                            "prefill": {
                              "name": user.contact.person_name,
                              "email": user.contact.email
                            },
                            "notes": {
                            },
                            "theme": {
                            }
                        };
                        let rp = new Razorpay(options);
                        rp.on('payment.failed', function (response){
                            window.location.href = `/account/invoices/${invoice.id}?rpErr=`+btoa(JSON.stringify(response));
                        });
                        rp.open();
                    }
                },
                formURL(type) {
                    const return_url = "/build-server"
                    if (!return_url) return null
                    let url
                    if (this.checkoutInfo.info && this.checkoutInfo.info[type]) {
                        url = `/add-payment-item/${type}/${this.checkoutInfo.info[type].type}`
                    } else {
                        url = `/add-payment-item/${type}`
                    }
                    return url + "?" + $.param({ return_url: return_url })
                },
                /** @param {(string | number)} bandwidthAmount */
                selectBandwidth(bandwidthAmount) {
                    this.cloudServerBuilder.predictedBandwidth = bandwidthAmount
                },
                /** @param {Object} cloudProduct */
                selectCloudProduct(cloudProduct) {
                    if (cloudProduct) {
                        const availableZones = this.cloudProductHelper.availableZones(
                            cloudProduct.detail.provider.options[0], cloudProduct.specName
                        )

                        this.cloudServerBuilder.selectCloudProduct(cloudProduct, availableZones)
                    }
                },
                /** @param {(string | number)} diskAmount */
                selectDiskSpace(diskAmount) {
                    this.cloudServerBuilder.configuredDiskSpace = diskAmount
                },
                /** @param {string} zone */
                selectZone(zone) {
                    this.cloudServerBuilder.zone = zone
                },
                async submitCardForm() {
                    const vue = this
                    const driver = await PaymentInfoCapture.drivers.card.getDriver()
                    if (!driver) {
                        throw new Error("No card capture driver available")
                    }
                    try {
                        if ('payment-selection-card' in vue.$refs) {
                            // @ts-ignore
                            vue.$refs['payment-selection-card'].submittingCapture = true
                        }

                        await driver.submitForm()

                        if ('payment-selection-card' in vue.$refs) {
                            // @ts-ignore
                            vue.$refs['payment-selection-card'].submittingCapture = false
                        }

                        /** Close card capture after form submission with exception of Worldpay */
                        if (('payment-selection-card' in vue.$refs) && !(driver instanceof CardCaptureWorldpay)) {
                            const child = vue.$refs['payment-selection-card']
                            // @ts-ignore
                            if (child.showCaptureInline) {
                                // @ts-ignore
                                child.showCaptureInline = false
                            }
                        }

                        PaymentItemCollection.inst.reload(["items"])
                    } catch (e) {
                        if ('payment-selection-card' in vue.$refs) {
                            // @ts-ignore
                            vue.$refs['payment-selection-card'].submittingCapture = false
                        }
                        ShowNotification.fail(
                            translation.get('checkout_notification_fail_add_card')
                        )
                    }
                },
                /**
                 * RESPONSIVE
                 */
                responsiveOptimisationSelectOption(option) {
                    // Dark theme is not supported in stackcp...
                    const dm = localStorage.getItem('dark-theme')
                    const dark = (dm && dm === '1') ? true : false
                    // Hence this code
                    const icon = this.selectedTheme ? option?.icon?.lightMode : option?.icon?.darkMode
                    const html = /*html*/
                        `<div class="d-flex align-items-center justify-content-start h-100">\
                            <div class="d-flex justify-content-center" style="width: 20%">\
                                <img style="width: 50px" class="pe-2" src="${icon}">\
                            </div>\
                            <table>\
                                <tr>\
                                    <td>${option.title}${(!option.available ? `<span class="cta ms-3 py-1 px-2">Coming soon!</span>` : ``)}</td>\
                                </tr>
                                ${(option.version ? `<tr>\
                                    <td style="font-weight: 400;">\
                                        Version ${option.version} Optimised\
                                    </td>\
                                </tr>` : ``)}
                            </table>`

                    return $(html)
                },
                responsiveServerSelectOption(option) {
                    if (option.loading) return false

                    const price = this.cloudProductHelper.serverBasePrice(
                        this.cloudServerBuilder.cloudProvider,
                        option.specName,
                        this.cloudServerBuilder.zone,
                        this.catalogue.currency,
                        false,
                        true,
                        this.catalogue.currency,
                    );

                    if (this.cloudServerBuilder.specName && this.cloudServerBuilder.zone) {
                        let html = ""
                        html =
                            `<div class="d-flex flex-column justify-content-around text-start p-2">\
                                <span class="text-start p-1">${option.uiLabel}\
                                    <span class="text-primary fw-bold">\
                                        ${Site.Format.price(price, this.catalogue.currency)}/mo\
                                    </span>\
                                </span>\
                                <table>\
                                    <tr>\
                                        <td class="p-1 pe-3">\
                                            <strong>${option.detail.cpu.options[0]}</strong> Core\
                                        </td>\
                                        <td class="p-1">\
                                            <strong>${option.detail.ram.options[0]}${option.detail.ram.uiLabel}</strong> RAM\
                                        </td>\
                                    </tr>\
                                    ${(option.detail.disk.range.min == option.detail.disk.range.max ? `<tr>\
                                        <td class="p-1 pe-3">\
                                            <strong>${option.detail.disk.range.min}${option.detail.disk.uiLabel}</strong> SSD\
                                        </td>\
                                        <td class="p-1">\
                                            <strong>${this.cloudProductHelper.formatBandwidth(option.detail.bandwidth.options[0], option.detail.bandwidth.uiLabel)}</strong> Bandwidth\
                                        </td>\
                                    </tr>` : ``)}
                                </table>\
                            </div>`

                        return $(html)
                    }
                },
            },
            async mounted() {
                this.catalogue.assertExists()

                try {
                    const [cloudProducts, baseProducts] = await Promise.all([
                        $.ajax(`/a/catalogue/cloudProducts`),
                        $.ajax(`/a/catalogue/cloudProducts?base=true`),
                        this.user.preloadSingle("identityInfo").catch(() => {}),
                    ])
                    this.cloudProductHelper = new ResellerCloudProductHelper(cloudProducts, this.brand)
                    // Get the 20i JSON as the base (reference) pricing for markups
                    this.cloudProductHelper.base = baseProducts
                } catch (e) {
                    console.error("Failed to load cloud products", e)
                } finally {
                    // catalogue.isOpen may have resolved before Promise.all completed, in
                    // which case the watcher skipped clearing loading — handle that here
                    if (this.catalogue.isOpen != null) {
                        this.loading = false
                    }
                }

                // Load existing config if it exists
                if (sessionStorage.getItem('cloudServerBuildSpec')) {
                    // @ts-ignore
                    const importSpec = JSON.parse(sessionStorage.getItem('cloudServerBuildSpec'))

                    // Build the object
                    this.cloudServerBuilder.importConfig(importSpec)

                    // Clean up
                    sessionStorage.removeItem('cloudServerBuildSpec')
                }

                const urlParams = new URLSearchParams(window.location.search);
                const sParam = urlParams.get('s');
                if (sParam) {
                    // Base64 decode the value
                    const decodedString = atob(sParam);

                    try {
                        const s = JSON.parse(decodedString);
                        this.cloudServerBuilder.importConfig({
                            optimisationProfile: s.p,
                            cloudProvider: s.e,
                            timelineBackups: s.t ? 'pro' : null,
                            specName: s.s,
                            configuredDiskSpace: s.d,
                            zone: s.z
                        });
                    } catch (error) {
                        // Do nothing
                    }
                }

                this.userId = this.user.identityInfo?.content;

                $.ajax({
                    method: "get",
                    url: `/n/payment/paymentItem`,
                    data: {
                        selector: {
                            owner: this.userId,
                        },
                        fields: [
                            "display",
                            "owner",
                            "type",
                            "id",
                            "isBillable",
                            "availableNonPayable",
                            "availablePayable",
                            "availableBalance"
                        ]
                    }
                }).then(res => {
                    this.paymentItems = res.filter(i => i.type == 'card' || i.type == 'balance')
                    this.balance = res.find(i => i.type == 'balance')
                    const defaultSelection = this.paymentItems.find(
                        i => i.type == 'card' && i.isBillable
                    )

                    if (defaultSelection) {
                        this.selectedPaymentItem = defaultSelection
                    } else if (this.checkoutInfo.supportedPaymentTypes.includes("razorpay") ) {
                        this.useRazorpay = true;
                    }
                })

                this.basket.reset()

                const targetNode = document.getElementById("build-server");
                const config = { attributes: true, childList: true, subtree: true };
                let tooltipRafId = null;
                const callback = () => {
                    if (tooltipRafId) return;
                    tooltipRafId = requestAnimationFrame(() => {
                        tooltipRafId = null;
                        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
                            if (!bootstrap.Tooltip.getInstance(el)) {
                                new bootstrap.Tooltip(el);
                            }
                        });
                    });
                };
                const observer = new MutationObserver(callback);
                observer.observe(targetNode, config);
            }
        })
    }
}
